<template>
  <div id="page-user-edit" class="flex items-center justify-center min-h-screen bg-gray-100 bg-img">
    <vx-card class="w-full max-w-lg p-6 shadow-lg rounded-lg bg-white" v-if="operation_data">
      
      <div slot="no-body" class="tabs-container">
        <!-- Logo en haut de la carte -->
        <div class="flex justify-center mb-6">
          <img src="https://xylo.codesinn.com/logo-xylo-impact.svg" alt="Logo XYLO Impact" class="h-16">
        </div>
        <div class="flex justify-center mb-6">
          <h2 class="text-xl font-semibold">Chestionar pentru șoferi</h2>
        </div>


        <div slot="no-body" class="tabs-container">
          <div class="tab-text">
            <div id="user-edit-tab-info">
              <!-- Content Row -->
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="flex flex-col space-y-4">
                    <!-- Informations du Chauffeur -->
                    <div class="flex flex-col md:flex-row md:space-x-4">
                      <div class="flex-1">
                        <vs-input label="Prenume și Nume de familie șofer" v-model="operation_data.driver"
                          class="w-full" />
                      </div>
                      <div class="flex-1">
                        <vs-input label="Telefon șofer" v-model="operation_data.driver_phone" class="w-full" />
                      </div>
                    </div>

                    <!-- Plaques du Camion et de la Remorque -->
                    <div class="flex flex-col md:flex-row md:space-x-4">
                      <div class="flex-1">
                        <vs-input label="Nr de imatriculare Camion" v-model="operation_data.truck_plate" class="w-full" />
                      </div>
                      <div class="flex-1">
                        <vs-input label="Nr de imatriculare Remorcă" v-model="operation_data.trailer_plate" class="w-full" />
                      </div>
                    </div>

                    <!-- Commutateurs Boolean -->
                    <div class="grid grid-cols-1 md:grid-cols-1 gap-4">
                      <!-- Transportator Chingi -->
                      <div class="flex items-center p-3 bg-yellow-100 border border-yellow-300 rounded">
                        <span class="mr-4">1. Am 24 de chingi?</span>
                        <vs-switch color="primary" icon-pack="feather" vs-icon-on="icon-yes" vs-icon-off="icon-no"
                          v-model="operation_data.check_transporter_chingi">
                          <span slot="on">DA</span>
                          <span slot="off">NU</span>
                        </vs-switch>
                      </div>

                      <!-- Transportator Coltare -->
                      <div class="flex items-center p-3 bg-yellow-100 border border-yellow-300 rounded">
                        <span class="mr-4">2. O să pun colțare la mobilierul de grădină?</span>
                        <vs-switch color="primary" icon-pack="feather" vs-icon-on="icon-yes" vs-icon-off="icon-no"
                          v-model="operation_data.check_transporter_coltare">
                          <span slot="on">DA</span>
                          <span slot="off">NU</span>
                        </vs-switch>
                      </div>

                      <!-- Transportator SSM -->
                      <div class="flex items-center p-3 bg-yellow-100 border border-yellow-300 rounded">
                        <span class="mr-4">3. Respect regulile SSM?</span>
                        <vs-switch color="primary" icon-pack="feather" vs-icon-on="icon-yes" vs-icon-off="icon-no"
                          v-model="operation_data.check_transporter_ssm">
                          <span slot="on">DA</span>
                          <span slot="off">NU</span>
                        </vs-switch>
                      </div>

                      <!-- Transportator Respectuos -->
                      <div class="flex items-center p-3 bg-yellow-100 border border-yellow-300 rounded">
                        <span class="mr-4">4. Am un comportament respectuos și politicos?</span>
                        <vs-switch color="primary" icon-pack="feather" vs-icon-on="icon-yes" vs-icon-off="icon-no"
                          v-model="operation_data.check_transporter_respectuos">
                          <span slot="on">DA</span>
                          <span slot="off">NU</span>
                        </vs-switch>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Bouton Enregistrer -->
              <div class="vx-row mt-6">
                <div class="vx-col w-full">
                  <div class="flex justify-end">
                    <vs-button color="success" @click="save_changes" :disabled="!validateForm">
                      Salvează Modificările
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>



<script>
import vSelect from "vue-select";
import axios from "@/axios.js";
import Datepicker from "vuejs-datepicker";
import moduleOperationList from "@/store/operation/moduleOperationList.js";
import moment from "moment";

export default {
  components: {
    vSelect,
    Datepicker,
  },
  data() {
    return {
      firstload7days: true,
      paymentmtd: null,
      statusId: null,
      data_option_payment_status: [],
      dataTransitDate: null,
      operation_data: null,
      invoiceattached: null,
      selected: [],
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      buttonSubmitOpen: false,
      state: {},
      personId: null,
      invoicetounlink: null,
      data_option_operation: [],
      linkedOperationId: [],
      data_option_billing_address: [],
      data_option_delivery_address: [],
      remorcatip: null,
      transporttip: null,
      billingAddressId: null,
      deliveryAddressId: null,
      transportCost: null,
      paymentDeadline: null,
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    },
  },
  methods: {
    calculateTotal() {
      this.dataTotalPrice = this.dataUnitPrice * this.dataQuantity;
    },
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    save_changes() {
      const obj = {
        id: this.operation_data.id,
        driver: this.operation_data.driver,
        driver_phone: this.operation_data.driver_phone,
        truck_plate: this.operation_data.truck_plate,
        trailer_plate: this.operation_data.trailer_plate,
        check_transporter_chingi: this.operation_data.check_transporter_chingi,
        check_transporter_coltare: this.operation_data.check_transporter_coltare,
        check_transporter_ssm: this.operation_data.check_transporter_ssm,
        check_transporter_respectuos: this.operation_data.check_transporter_respectuos,
      };

      if (this.operation_data.id) {
        this.$store
          .dispatch("operationList/updateOperation", obj)
          .catch((err) => {
            console.error(err);
          });
        this.$router.push({ name: "app-transporter-code-forms" });

        this.$vs.notify({
          color: "success",
          title: "Operation Updated!",
          text: "The transport was successfully updated",
        });
      }
    },
    fetch_operation_data(userId) {
      if (userId) {
        this.$store
          .dispatch("operationList/fetchOperation", userId)
          .then((res) => {
            this.operation_data = res.data;
            if (res.data.operationcategory.id !== 7) {
              this.$router.push({ name: "app-transporter-code-forms" });
              this.$vs.notify({
                color: "warning",
                title: "Wrong transport code!",
                text: "Please select a valid transport code",
              });
            }
          })
          .catch((err) => {
            this.$router.push({ name: "app-transporter-code-forms" });
              this.$vs.notify({
                color: "warning",
                title: "Wrong transport code!",
                text: "Please select a valid transport code",
              });
          });
      } else {
        this.operation_data = {};
      }
    },
  },

  created() {
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule("operationList", moduleOperationList);
      moduleOperationList.isRegistered = true;
    }
    this.fetch_operation_data(this.$route.params.userId);
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
